<!-- Backdrop del modal -->
<div class="modal-backdrop" *ngIf="isOpen" (click)="closeModal()"></div>

<!-- Modal -->
<div class="date-range-modal" *ngIf="isOpen">
  <div class="modal-header">
    <h3>Seleccionar Rango de Fechas</h3>
    <button class="close-btn" (click)="closeModal()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="modal-body">
    <!-- Botones de acceso rápido por siglos -->
    <div class="quick-actions">
      <button
        class="quick-btn"
        [class.active]="activeQuickRange === 'siglo19'"
        (click)="setQuickRange('siglo19')">
        Siglo XIX (1825-1899)
      </button>
      <button
        class="quick-btn"
        [class.active]="activeQuickRange === 'siglo20'"
        (click)="setQuickRange('siglo20')">
        Siglo XX (1900-1999)
      </button>
      <button
        class="quick-btn"
        [class.active]="activeQuickRange === 'siglo21'"
        (click)="setQuickRange('siglo21')">
        Siglo XXI (2000-Hoy)
      </button>
      <button
        class="quick-btn"
        [class.active]="activeQuickRange === 'bicentenario'"
        (click)="setQuickRange('bicentenario')">
        Archivo Completo (1825-Hoy)
      </button>
    </div>

    <!-- Tabs para seleccionar calendario con fechas en el header -->
    <div class="calendar-tabs">
      <button
        class="tab-button"
        [class.active]="activeTab === 'start'"
        (click)="activeTab = 'start'">
        <div class="tab-content">
          <div class="tab-header">
            <i class="bi bi-calendar-check"></i>
            <span class="tab-title">Fecha Inicio</span>
          </div>
          <div class="tab-date">
            <span *ngIf="startDate" class="date-selected">{{ startDate | date: 'dd/MM/yyyy' }}</span>
            <span *ngIf="!startDate" class="date-placeholder">Seleccione fecha</span>
          </div>
        </div>
      </button>
      <button
        class="tab-button"
        [class.active]="activeTab === 'end'"
        (click)="activeTab = 'end'">
        <div class="tab-content">
          <div class="tab-header">
            <i class="bi bi-calendar-check-fill"></i>
            <span class="tab-title">Fecha Fin</span>
          </div>
          <div class="tab-date">
            <span *ngIf="endDate" class="date-selected">{{ endDate | date: 'dd/MM/yyyy' }}</span>
            <span *ngIf="!endDate" class="date-placeholder">Seleccione fecha</span>
          </div>
        </div>
      </button>
    </div>

    <!-- Contenedor del calendario -->
    <div class="calendar-container">
      <!-- Calendario Fecha Inicio -->
      <div class="calendar-section" *ngIf="activeTab === 'start'" [@fadeIn]>
        <div class="calendar-header">
          <h4>Seleccione Fecha de Inicio</h4>
        </div>

        <div class="month-year-selector">
          <div class="year-input-wrapper">
            <input
              type="number"
              [(ngModel)]="startYear"
              (focus)="onStartYearFocus($event)"
              (change)="onStartMonthYearChange()"
              (blur)="validateStartYear()"
              [min]="minDate.getFullYear()"
              [max]="maxDate.getFullYear()"
              class="year-input"
              placeholder="Año"
            />
            <div class="year-buttons">
              <button type="button" class="year-btn" (click)="incrementStartYear()">
                <i class="bi bi-chevron-up"></i>
              </button>
              <button type="button" class="year-btn" (click)="decrementStartYear()">
                <i class="bi bi-chevron-down"></i>
              </button>
            </div>
          </div>
          <select [(ngModel)]="startMonth" (change)="onStartMonthYearChange()" class="month-select">
            <option *ngFor="let month of months; let i = index" [value]="i">
              {{ month }}
            </option>
          </select>
        </div>

        <div class="calendar-grid">
          <div class="calendar-weekdays">
            <div class="weekday" *ngFor="let day of weekDays">{{ day }}</div>
          </div>
          <div class="calendar-days">
            <div
              *ngFor="let day of startCalendarDays"
              class="calendar-day"
              [class.other-month]="!day.isCurrentMonth"
              [class.selected]="isStartDateSelected(day)"
              [class.in-range]="isDateInRange(day)"
              [class.disabled]="isStartDateDisabled(day)"
              (click)="selectStartDate(day)">
              {{ day.day }}
            </div>
          </div>
        </div>
      </div>

      <!-- Calendario Fecha Fin -->
      <div class="calendar-section" *ngIf="activeTab === 'end'" [@fadeIn]>
        <div class="calendar-header">
          <h4>Seleccione Fecha de Fin</h4>
        </div>

        <div class="month-year-selector">
          <div class="year-input-wrapper">
            <input
              type="number"
              [(ngModel)]="endYear"
              (focus)="onEndYearFocus($event)"
              (change)="onEndMonthYearChange()"
              (blur)="validateEndYear()"
              [min]="minDate.getFullYear()"
              [max]="maxDate.getFullYear()"
              class="year-input"
              placeholder="Año"
            />
            <div class="year-buttons">
              <button type="button" class="year-btn" (click)="incrementEndYear()">
                <i class="bi bi-chevron-up"></i>
              </button>
              <button type="button" class="year-btn" (click)="decrementEndYear()">
                <i class="bi bi-chevron-down"></i>
              </button>
            </div>
          </div>
          <select [(ngModel)]="endMonth" (change)="onEndMonthYearChange()" class="month-select">
            <option *ngFor="let month of months; let i = index" [value]="i">
              {{ month }}
            </option>
          </select>
        </div>

        <div class="calendar-grid">
          <div class="calendar-weekdays">
            <div class="weekday" *ngFor="let day of weekDays">{{ day }}</div>
          </div>
          <div class="calendar-days">
            <div
              *ngFor="let day of endCalendarDays"
              class="calendar-day"
              [class.other-month]="!day.isCurrentMonth"
              [class.selected]="isEndDateSelected(day)"
              [class.in-range]="isDateInRange(day)"
              [class.disabled]="isEndDateDisabled(day)"
              (click)="selectEndDate(day)">
              {{ day.day }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-clear" (click)="clearDates()">
      <i class="bi bi-x-circle"></i> Limpiar
    </button>
    <button class="btn-search" (click)="applyDates()" [disabled]="!startDate || !endDate">
      <i class="bi bi-search"></i> Buscar
    </button>
  </div>
</div>
